import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem9sm12xs12,
} from '../../../business-components/Grid/Grid'

 import {
    CardGridEntradaDados,
    CardGridEntradaDadosHeaderBody,
} from '../../../business-components/Card/Card'

import {
    processaValoresDefaultIniciaisConfiguracaoAcumulacao,
} from '../estudo-parametros/EstudoServiceConfiguracaoAcumulacao'

import {
    NaoExibirOpcaoAporteUnico,
    UtilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira,
} from '../estudo-parametros/EstudoCompConfiguracao'


const SimulacaoFinanceiraFormConfiguracao = ( { values, handleChange, handleSubmit } ) => {

    processaValoresDefaultIniciaisConfiguracaoAcumulacao(values)

    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer
                className="justify-center"
            >
                <GridItem9sm12xs12>
                    <CardGridEntradaDados>
                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.estrategiasPossiveis}
                        >     
                            <NaoExibirOpcaoAporteUnico
                                values={values}
                                handleChange={handleChange}
                            />
                        </CardGridEntradaDadosHeaderBody>

                        <CardGridEntradaDadosHeaderBody
                            title={LABEL.buttonVisualizarDiagnosticoAposentadoriaIndependenciaFinanceira}
                        >     
                            <UtilizarVersaoSimplificadaGraficoDiagnosticoAposentadoriaIndependênciaFinanceira
                                values={values}
                                handleChange={handleChange}
                            />                       
                        </CardGridEntradaDadosHeaderBody>
                    </CardGridEntradaDados>
                </GridItem9sm12xs12>
            </GridContainer>
        </ValidatorForm>
    )
}

export default SimulacaoFinanceiraFormConfiguracao